<ul class="breadcrumb">
	<li *ngFor="let item of path; index as index" [ngClass]="item.listItemClass!">
		<a *ngIf="links && item.labelKey" [routerLink]="item.route" translate="{{ item.labelKey }}"></a>
		<a *ngIf="links && !item.labelKey" [routerLink]="item.route">{{ item.label }}</a>
		<p *ngIf="!links && item.labelKey" translate="{{ item.labelKey }}"></p>
		<p *ngIf="!links && !item.labelKey">{{ item.label }}</p>
	</li>
</ul>
